<script setup lang="ts">
import { ref } from 'vue';

import { Locales } from '@/store/language.interface';
import { getTranslation } from '@/utils/data-display-utils';
import { Dot } from '@/store/form.Interface';

import BaseDialog from '@/components/base/BaseDialog.vue';

// CONST
const dotVotingChoiceDialogRef = ref<InstanceType<typeof BaseDialog>>();

// PROPS
const props = defineProps<{
  dot?: Dot;
  languageEnabled?: Locales[];
}>();

// FUNCTIONS
function openDialog() {
  dotVotingChoiceDialogRef.value?.openDialog();
}

function closeDialog() {
  dotVotingChoiceDialogRef.value?.closeDialog();
}

defineExpose({
  openDialog,
  closeDialog,
});
</script>
<template>
  <BaseDialog ref="dotVotingChoiceDialogRef" class="dot-vote-choice-dialog">
    <template v-slot:title>
      <div class="title">
        {{ getTranslation(props.dot, 'title', props.languageEnabled) }}
      </div>
    </template>
    <template v-slot:content>
      <div
        v-html="getTranslation(props.dot, 'long_text', props.languageEnabled)"
        class="dot-vote-choice-dialog ck-rich-text"
      />
    </template>
  </BaseDialog>
</template>
<style lang="scss">
.q-dialog {
  .title {
    font-size: $header;
  }
}
</style>
